import { z } from 'zod';
import { UUIDSchema } from './common';
import { TaskCreatedBySchema, NewOrderTaskSchema } from './tasks';
export const TimeDeltaUnitSchema = z.enum(['working_days', 'weeks']);
export const TaskDateTriggerSchema = z.enum(['valuation_date', 'order_creation_date', 'task_creation_date']);
export const TimeDeltaSchema = z.object({
    value: z.number(),
    unit: TimeDeltaUnitSchema,
});
export const NewTaskTemplateSchema = z.object({
    title: z.string(),
    description: z.string().optional(),
    template_type: z.literal('appraiser_created'),
    time_delta: TimeDeltaSchema.optional(),
    date_trigger: TaskDateTriggerSchema.optional(),
    has_limited_visibility: z.boolean(),
});
export const ExistingTaskTemplateSchema = NewTaskTemplateSchema.extend({
    uuid: UUIDSchema,
    organization_uuid: UUIDSchema,
    created_by: TaskCreatedBySchema,
});
export const TaskTemplateListSchema = z.object({ templates: ExistingTaskTemplateSchema.array() });
export const TaskPreviewSchema = z.object({
    title: z.string(),
    description: z.string().optional(),
    due_date: z.string().optional(),
    time_delta: TimeDeltaSchema.optional(),
    date_trigger: TaskDateTriggerSchema.optional(),
    has_limited_visibility: z.boolean(),
});
export const NewOrderTaskFromTaskPreviewSchema = NewOrderTaskSchema.extend({
    description: z.string().optional(),
    has_limited_visibility: z.boolean(),
});
export const TaskPreviewListSchema = z.object({ task_previews: TaskPreviewSchema.array() });
